// src/pages/Association.js
import React from 'react';

import { assets } from '../assets/asset_importer';

const Association = () => {
  // Shortcut to access the 2026 board images
  const board = assets.images.board["2026"];

  return (
    <div className="page association-page">
      <section className="page-header">
        <div className="container">
          <h1>Association and representatives</h1>
          <p>Information about Integralis, our board, and our officers</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          {/* About section */}
          <div className="info-card mb-2">
            <h3>About Integralis</h3>
            <p>
              Integralis ry is the student organisation for all international students at the Kumpula campus at University of Helsinki.
              Additionally we are the main student organization for the Bachelor’s Programme in Science. Our mission is to support students’ studies, well-being and
              social life.
            </p>
            <p>
              
              Our members study disciplines such as chemistry, computer science, mathematics, and physics in English at
              the Kumpula campus. The organisation was founded in 2019 and today has around 200 members, with
              dozens of new students joining each year.
            </p>
          </div>

          {/* Core board members */}
          <div className="mt-2">
            <h2>Core board members 2026</h2>
            <div className="board-grid">

              <div className="board-member">
                <img src={board.aleksii} alt="Aleksi" className="board-photo" />
                <h3>Aleksi Kiema</h3>
                <p><strong>President</strong></p>
                <p>aleksi.kiema@helsinki.fi</p>
                <p>@alekiema</p>
                <p className="mt-2">
                  “Never stop the madness”
                </p>
              </div>

              <div className="board-member">
                <img src={board.pradham} alt="Pradham" className="board-photo" />
                <h3>Pradham Pepakayala</h3>
                <p><strong>Vice-President</strong></p>
                <p>pradham.pepakayala@helsinki.fi</p>
                <p>@pradd_xd</p>
                <p className="mt-2">
                  “I keep it 100 like I'm runnin a fever”
                </p>
              </div>

              <div className="board-member">
                <img src={board.selma} alt="Selma" className="board-photo" />
                <h3>Selma Brambilla</h3>
                <p><strong>Secretary, Communications, and Klusteri Officer</strong></p>
                <p>selma.brambilla@helsinki.fi</p>
                <p>@selma_06</p>
                <p className="mt-2">“Never say no to a random side quest.”</p>
              </div>

              <div className="board-member">
                <img src={board.aki} alt="Aki" className="board-photo" />
                <h3>Aki Laaksonen</h3>
                <p><strong>Treasurer</strong></p>
                <p>aki.laaksonen@helsinki.fi</p>
                <p>@anterolius</p>
                <p className="mt-2">“Money doesn't grow on trees”</p>
              </div>

            </div>
          </div>

          {/* Other board members */}
          <div className="mt-2">
            <h2>Board members 2026</h2>
            <div className="board-grid">

              <div className="board-member">
                <img src={board.antoine} alt="Antoine" className="board-photo" />
                <h3>Antoine Guerin Heinrichs</h3>
                <p><strong>Foreign Minister</strong></p>
                <p>antoine.guerinheinrichs@helsinki.fi</p>
                <p>@AGKimmoCult</p>
                <p className="mt-2">
                “Tolerance becomes a crime when applied to evil.” – Thomas Mann
                </p>

              </div>

              <div className="board-member">
                <img src={board.daniel} alt="Daniel" className="board-photo" />
                <h3>Daniel Mlesnita</h3>
                <p><strong>Career's Officer</strong></p>
                <p>daniel.mlesnita@helsinki.fi</p>
                <p>@Nushu_OoO</p>
                <p className="mt-2">
                  “One should aim to be a little greater than their fate.”
                </p>
              </div>

              <div className="board-member">
                <img src={board.janne} alt="Janne" className="board-photo" />
                <h3>Janne Lindqvist</h3>
                <p><strong>IT Officer</strong></p>
                <p>janne.mc.lindqvist@helsinki.fi</p>
                <p>@Janaanibanaani</p>
                <p className="mt-2">
                “I've been twinking about it.”
                </p>                
              </div>

              <div className="board-member">
                <img src={board.cicek} alt="Cicek" className="board-photo" />
                <h3>Çiçek Aykaç</h3>
                <p><strong>Harassment Contact Person</strong></p>
                <p>cicek.aykac@helsinki.fi</p>
                <p>@cicekaa</p>
                <p className="mt-2">
                “Age is something that doesn't matter, unless you are a cheese.” - Luis Buñuel
                </p>                 
              </div>

              <div className="board-member">
                <img src={board.dasha} alt="Dasha" className="board-photo" />
                <h3>Daria Chesnokova</h3>
                <p><strong>Graphical Design, Merchandise, and Equality Officer </strong></p>
                <p>daria.chesnokova@helsinki.fi</p>
                <p>@dikobrasha</p>
                <p className="mt-2">
                    “There’s that old saying: liquor before beer…”
                </p>                  
              </div>

              <div className="board-member">
                <img src={board.andrejs} alt="Andrejs" className="board-photo" />
                <h3>Andrejs Freibergs</h3>
                <p><strong>Hideout Officer</strong></p>
                <p>andrejs.freibergs@helsinki.fi</p>
                <p>@freibergsandrejs</p>
                <p className="mt-2">
                    "To most things, I prefer lying in a flower field"
                </p>                 
              </div>

              <div className="board-member">
                <img src={board.ruta} alt="Ruta" className="board-photo" />
                <h3>Ruta Demitere</h3>
                <p><strong>Events, and Matlu Officer</strong></p>
                <p>ruta.demitere@helsinki.fi</p>
                <p>@rutarenate</p>
                <p className="mt-2">
                 "Be yourself, everyone else is taken." - Oscar Wilde
                </p> 
              </div>

              <div className="board-member">
                <img src={board.oliwia} alt="Oliwia" className="board-photo" />
                <h3>Oliwia Salwocka</h3>
                <p><strong>Board Member</strong></p>
                <p>oliwia.salwocka@helsinki.fi</p>
                <p>@oliloli2</p>
              </div>

            </div>
          </div>

          
          {/* All officer roles in a list */}
          <div className="mt-2">
            <h2>Officers 2026</h2>
            <div className="board-grid">
              <div className="info-card">
              <h3>Communications officer</h3>
                <ul>
                  <li>Selma Brambilla</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Career's officer</h3>
                <ul>
                  <li>Daniel Mlesnita</li>
                </ul>
              </div>
              <div className="info-card">
              <h3>Events officer</h3>
                <ul>
                  <li>Ruta Demitere</li>
                </ul>
              </div>
              <div className="info-card">
              <h3>Studies officer & committee leader</h3>
                <ul>
                  <li>Filip Raso</li>
                </ul>
              </div>
            
              <div className="info-card">
              <h3>IT officers</h3>
                <ul>
                  <li>Janne Lindqvist</li>
                  <li>Dmitrii Gorovoi</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Overalls officer</h3>
                <ul>
                  <li>George Tsonev</li>
                </ul>
              </div>

              <div className="info-card">

              <h3>Harassment contact persons</h3>
                <ul>
                  <li>Aykaç Çiçek</li>
                  <li>Arjun Menon Tiwari</li>
                  <li>Hendrik Erik Raidal</li>
                </ul>
              </div>
            
              <div className="info-card">
              <h3>HYY officer</h3>
                <ul>
                  <li>Arjun Menon Tiwari</li>
                </ul>
              </div>
            
              <div className="info-card">
              <h3>Foreign minister</h3>
                <ul>
                  <li>Antoine Guerin Heinrichs</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Matlu international committee officer</h3>
                <ul>
                  <li>Ruta Demitere</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>SFMO responsible </h3>
                <ul>
                  <li>Jeff Schymiczek</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>TEK & Loimu Responsible</h3>
                <ul>
                  <li>Trang Nguyen</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Hideout Officer</h3>
                <ul>
                  <li>Andrejs Freibergs</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Graphical Design Officer</h3>
                <ul>
                  <li>Daria Chesnokova</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Merchandise Officer</h3>
                <ul>
                  <li>Daria Chesnokova</li>
                </ul>
              </div>
              
              <div className="info-card">
              <h3>Environmental Officers</h3>
                <ul>
                  <li>George Tsonev</li>
                  <li>Sandro Vazquez</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Songbook Officer</h3>
                <ul>
                  <li>Jeff Schymiczek</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Equality Officer</h3>
                <ul>
                  <li>Daria Chesnokova</li>
                </ul>
              </div>

              <div className="info-card">
              <h3>Tutor coordinators</h3>
                <ul>
                  <li>Filip Raso</li>
                  <li>Michal Kwak</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact & official info */}
          <div className="mt-2">
            <h2>About integralis</h2>
            <div className="mt-2 board-grid">
            <div className="info-card">
              <h3>Hideout – student room</h3>
              <p>Room C131, Exactum</p>
              <p>Pietari Kalmin katu 5</p>
              <p>00560 Helsinki</p>
            </div>

            <div className="info-card">
              <h3>Official details</h3>
              <p>Postal address: PL 68, 00014 Helsingin yliopisto</p>
              <p>Email: integralis@helsinki.fi</p>
              <p>Business ID (Y-tunnus): 3115891-9</p>
              <p>IBAN: FI95 5780 0720 5620 45</p>
              <p>BIC: OKOYFIHH</p>
            </div>

            <div className="info-card">
              <h3>Member of Matlu ry</h3>
              <p>
                Integralis is a member of Matlu ry, the lobbying and cooperation organisation for the
                Faculty of Science student associations at the University of Helsinki.
              </p>
              <p>
                Learn more:{' '}
                <a href="https://matlu.fi" target="_blank" rel="noopener noreferrer">
                  matlu.fi
                </a>
              </p>
            </div>

          </div>
          </div>
        </div>

        
      </section>
    </div>
  );
};

export default Association;